/* eslint-disable import/prefer-default-export */
import apiClient from './apiClient';
import { RESTAURANT_DESIGN_FONTS } from '../constants/UriConstants';
import {
  RestaurantFontSettingsInterface,
  RestaurantFontSettingsResponseInterface
} from '../types/RestaurantTypographyInterface';

export const getRestaurantFontSettings = (): Promise<RestaurantFontSettingsResponseInterface> =>
  apiClient.get(RESTAURANT_DESIGN_FONTS).then((response) => response.data);

export const saveRestaurantFontSettings = (
  fonts: RestaurantFontSettingsInterface
): Promise<RestaurantFontSettingsResponseInterface> =>
  apiClient.put(RESTAURANT_DESIGN_FONTS, fonts).then((response) => response.data);
